var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Mutation, State } from "vuex-class";
var NavInfo = /** @class */ (function (_super) {
    __extends(NavInfo, _super);
    function NavInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.routeInfos = [];
        return _this;
    }
    NavInfo.prototype.onRouteChange = function (val) {
        this.routeInfos = [];
        if (val) {
            var info_1 = this.menuResource.find(function (x) { return x.url === val; });
            if (!info_1)
                return;
            this.routeInfos.unshift(info_1);
            info_1 = this.menuResource.find(function (x) { return x.id === info_1.parent; });
            if (!info_1)
                return;
            this.routeInfos.unshift(info_1);
        }
    };
    __decorate([
        State
    ], NavInfo.prototype, "menuCollapse", void 0);
    __decorate([
        State
    ], NavInfo.prototype, "menuResource", void 0);
    __decorate([
        Mutation
    ], NavInfo.prototype, "updateMenuCollapse", void 0);
    __decorate([
        Watch("$route.path", { immediate: true })
    ], NavInfo.prototype, "onRouteChange", null);
    NavInfo = __decorate([
        Component({
            components: {}
        })
    ], NavInfo);
    return NavInfo;
}(Vue));
export default NavInfo;
